export default "__VITE_ASSET__WP2O00Lu__"